module.exports = __webpack_public_path__ + "static/media/bcg_logo.e2a91558.png";